module.exports = __webpack_public_path__ + "img/preview-9.36f8bb15.png";